'use strict';

angular.module('mean.timecards').factory('timeService', ['$filter', 'toaster', 'Trades', '$q',
    function ($filter, toaster, Trades, $q) {


        var getStandardHours = function (trade, company_code) {
            var deferred = $q.defer();
            Trades.query({ 'trade': trade, 'company_code': company_code }, function (trades) {
                if (trades.length !== 1) {
                    toaster.pop('error', 'Error Getting Trade',
                        'Cannot retrieve the trade information from timeService');
                    deferred.reject('Error');
                    return;
                }
                if (!trades.length) {
                    return;
                }
                var typical_hour = {
                    clock_in: new Date(trades[0].typical_clock_in),
                    lunch_start: new Date(trades[0].typical_lunch_start),
                    lunch_end: new Date(trades[0].typical_lunch_end),
                    clock_out: new Date(trades[0].typical_clock_out),
                    mandatory_lunch: trades[0].mandatory_lunch,
                    lunch_minimum: trades[0].lunch_minimum
                }

                deferred.resolve(typical_hour);
            });

            return deferred.promise;
        };

        return {
            getStandardHours: getStandardHours
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/timecards/public/services/time-service.js